import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import React, { type MouseEvent, useState } from 'react';
import useAnchorMenu from '../../../hooks/useAnchorMenu';
import type { TripCard } from '../../../redux/trip/trip.types';
import DropdownMenu from '../../shared/DropdownMenu';
import IconButton from '../../shared/IconButton';
import CardTagsModal from '../CardTagsModal/CardTagsModal';

import './ActionMenu.scss';

interface ActionMenuProps {
  card: TripCard;
  tripId: string;
  canEdit?: boolean;
  isLarge?: boolean;
  onRename?: () => void;
  onChangeCoverPhoto?: () => void;
  onDelete?: (event: MouseEvent<EventTarget>) => void;
}

function ActionMenu({
  card,
  tripId,
  canEdit = false,
  isLarge = false,
  onRename,
  onChangeCoverPhoto,
  onDelete,
}: ActionMenuProps) {
  const menu = useAnchorMenu();
  const [tagsModalOpen, setTagsModalOpen] = useState(false);

  if (!canEdit) {
    return null;
  }

  return (
    <>
      <IconButton
        className={`action-menu-button${isLarge ? ' large' : ''}`}
        label='More actions'
        icon={<MoreHorizIcon />}
        onClick={menu.open}
      />

      <DropdownMenu {...menu.menuProps}>
        <DropdownMenu.Item
          icon={<DriveFileRenameOutlineIcon fontSize='small' />}
          deferUntilClosed
          onSelect={() => onRename?.()}
        >
          Rename Card
        </DropdownMenu.Item>
        <DropdownMenu.Item
          icon={<ImageOutlinedIcon fontSize='small' />}
          deferUntilClosed
          onSelect={() => onChangeCoverPhoto?.()}
        >
          Change Cover Photo
        </DropdownMenu.Item>
        <DropdownMenu.Item
          icon={<LocalOfferOutlinedIcon fontSize='small' />}
          deferUntilClosed
          onSelect={() => setTagsModalOpen(true)}
        >
          Edit Tags
        </DropdownMenu.Item>
        <DropdownMenu.Separator />
        <DropdownMenu.Item
          tone='danger'
          icon={<DeleteOutlinedIcon fontSize='small' />}
          onSelect={(event) => {
            event.stopPropagation();
            onDelete?.(event);
          }}
        >
          Delete
        </DropdownMenu.Item>
      </DropdownMenu>

      <CardTagsModal
        card={card}
        tripId={tripId}
        open={tagsModalOpen}
        onClose={() => setTagsModalOpen(false)}
      />
    </>
  );
}

ActionMenu.displayName = 'ActionMenu';
export default ActionMenu;
